function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "164.165,76.398 159.775,82.163 154.578,77.901 149.738,79.863 147.313,91.629 136.923,94.521  135.195,97.75 132.196,100.291 132.768,105.716 135.543,106.059 136.583,102.596 142.125,105.137 142.583,115.52 137.968,121.521  135.543,119.565 121.578,131.101 125.388,139.414 129.193,140.567 130.351,146.56 132.541,147.718 131.161,153.491 142.929,163.3  139.58,165.027 152.738,171.837 151.354,174.721 146.97,175.303 139.58,172.994 133.58,177.031 133.349,182.686 135.777,183.84  133.58,189.605 135.543,196.764 133.58,200 131.733,197.69 129.776,199.415 124.924,197.345 119.384,189.26 110.388,190.419  108.767,185.571 106,186.495 104.962,183.612 85.801,178.415 74.147,180.723 68.608,193.878 63.989,190.76 56.604,191.573  51.184,181.303 46.57,175.649 47.951,171.61 50.606,171.61 47.606,164.68 52.569,154.645 51.759,144.024 54.184,135.368  47.606,124.986 44.951,122.675 35.835,79.056 63.989,29.891 70.223,22.967 74.376,10.272 79.569,4.618 88.337,0 98.608,3.118  112.578,4.04 119.736,9.695 121.351,13.734 127.006,16.042 128.735,19.277 135.543,24.354 136.123,27.009 139.352,30.126  149.738,52.049 151.586,61.513 "
});

var Svg05 = function Svg05(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "COAH",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg05, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/05.2cb6ea8f.svg";
export { ForwardRef as ReactComponent };